import type { PlayerPublicState } from "@hitster/shared";
import type { PlayerColor } from "../lib/playerColors";
import { TimelineCard } from "./TimelineCard";
import { InsertionSlot } from "./InsertionSlot";

interface Props {
  timeline: PlayerPublicState["timeline"];
  selectedIndex: number | null;
  canPlace: boolean;
  onSelect: (index: number) => void;
  compact?: boolean;
  playerColorById?: Map<string, PlayerColor>;
}

export function Timeline({
  timeline,
  selectedIndex,
  canPlace,
  onSelect,
  compact,
  playerColorById,
}: Props) {
  return (
    <div className="timeline-scroll pb-1 sm:pb-2">
      <div className="flex items-center gap-1 sm:gap-2 min-w-min px-0.5 sm:px-1 py-1.5 sm:py-3">
        {canPlace && <InsertionSlot index={0} selected={selectedIndex === 0} onSelect={onSelect} />}
        {timeline.map((song, i) => (
          <div key={`${song.id}-${i}`} className="flex items-center gap-1 sm:gap-2">
            <TimelineCard
              song={song}
              compact={compact}
              playerColor={
                song.placedByPlayerId && playerColorById
                  ? playerColorById.get(song.placedByPlayerId)
                  : undefined
              }
            />
            {canPlace && (
              <InsertionSlot index={i + 1} selected={selectedIndex === i + 1} onSelect={onSelect} />
            )}
          </div>
        ))}
        {timeline.length === 0 && !canPlace && (
          <p className="text-violet-400/40 text-xs sm:text-sm italic px-2 sm:px-4">Frise vide</p>
        )}
        {timeline.length === 0 && canPlace && (
          <p className="text-violet-400/50 text-xs sm:text-sm ml-2 sm:ml-4">Choisissez la première position</p>
        )}
      </div>
    </div>
  );
}
